import { gql } from "@apollo/client";

export const GET_ALL_CARTS = gql`
query GetAllCarts {
  cart {
    all {
      id
      name
    }
  }
}
`;

export const GET_CART = gql`
query GetCart($id: ID!) {
  cart {
    get(id: $id) {
      id
      sellerID
      seller {
        id
        fullName
        telephone
        code
        address
        ward {
          name
          version
        }
        city {
          name
        }
        debtLimit
        debtAge
        availabilityLimit
        isActive
        currentAvailable
        currentDebt
        warehouses {
          id
          code
          name
          address
          ward {
            name
            version
          }
          city {
            name
          }
          branch {
            id
            name
          }
        }
        vatInfo {
          defaultExportVat
        }
      }
      exportedWarehouse {
        id
        name
      }
      items {
        id
        product {
          id
          code
          name
          warranty
          vat
          vatValue
          vatType
          vatPercent
          isActive
          productType
          uom {
            name
          }
          priceOfSeller {
            price
            level
          }
          stocks {
            productID
            quantity
            quantityRealStock
            quantityRealStockHasVat
            warehouse {
              id
              code
              name
              regionID
            }
            quantityRealStock
            quantityRealStockHasVat
          }
          minOrderQuantity
        }
        vat
        price
        priceLevel
        quantity
        total
        maxDaysOfDebt
        inStock
        customerPrice
        customerTotal
        productWarranty
      }
      subTotal
      totalProduct
      cashPayment
      debtPayment
      senderName
      senderPhone
      senderAddress
      allSenders {
        id
        fullName
        telephone
        address
        wardID
        cityID
        ward {
          name
          version
        }
        city {
          name
        }
        isDefault
      }
      shippingContact {
        id
        fullName
        telephone
        address
        ward {
          name
          id
          version
        }
        district {
          name
        }
        city {
          name
        }
        wardID
        cityID
      }
      note
      internalNote
      orderType
      shippingType
      orderPriority
      shippingConfiguration {
        busConfig {
          busName
          busStation
          telephone
          location
          fee
        }
        deliver3PartyConfig {
          name
          weight
          length
          width
          height
          fee
          serviceCode
          customFeeEnabled
          customFee
          providerID
          carrierMethod
          carrierMaxFee
          carrierMinFee
        }
        urbanConfig {
          fee
        }
      }
      deliveryDeadline
      fullStockRequired
      paymentMethod
      customerPaymentMethod
      vat
      vatAllOrder
      vatTaxIDNumber
      vatCompanyName
      vatEmail
      vatAddress
      shippingFee
      serviceFee
      temporaryServiceFee
      total
      discountAmount
      loyaltyCashInfo {
        discountRate
      }
      loyaltyCashDiscount
      sendingWard {
        id
        district {
          id
          cityID
        }
        version
      }
      customerSubTotal
      customerTotal
      assemblyRequired
      totalServiceProduct
      quantityServiceProduct
      shippingInfo {
        pickupInfo {
          warehouseID
          warehouse {
            id
            name
            address
            city {
              name
            }
            district {
              name
            }
            ward {
              name
            }
          }
          receiver {
            id
            fullName
            phone
          }
        }
      }
    }
  }
}
`;

export const GET_SENDER = gql`
query GetSender {
  user {
    me {
      senderContacts {
        id
        fullName
        address
        ward {
          name
          version
        }
        city {
          name
        }
        telephone
        isDefault
      }
    }
  }
}
`;

export const GET_SHIPPING_PROVIDER_SERVICE_FEE = gql`
query GetShippingProvider($serviceFeeInput: GetShippingServiceFeeInput!) {
  shippingProvider {
    servicesFee(serviceFeeInput: $serviceFeeInput) {
      method
      carrierMinFee
      carrierMaxFee
      providers {
        id
        code
        name
        fee
        logo_url
        id
        __typename
      }
      __typename
    }
    __typename
  }
}
`;

export const GET_SHIPPING_TYPES = gql`
  query GetShippingTypesV2($input: GetShippingTypesInput) {
    shippingProvider {
      getShippingTypesV2(input: $input) {
        shippingType
        isActive
        zone
        fee
        name
        logo
        shortDescription
        description
        message
      }
    }
  }
`;

export const GET_SHIPPING_PROVIDER = gql`
query GetShippingProvider {
  shippingProvider {
    list {
      id
      name
      carrierMethods
      fee
    }
  }
}
`;
